import React from "react";
import { Button } from "../catalyst/button";
import { PencilIcon, PlusIcon } from "@heroicons/react/24/outline";
import { Team } from "../../models/teamModel";
import { useTeamsStore } from "../../store/teamsStore";
import { useSeasonsStore } from "../../store/seasonsStore";

export const TeamActions: React.FC<{ team: Team; showEdit?: boolean }> = ({
  team,
  showEdit,
}) => {
  const { invitationDetails } = team;
  const { currentSeason } = useSeasonsStore();

  const {
    showInviteOwner,
    showInvitePlayer,
    showEditTeam,
    showShortlistPlayers,
  } = useTeamsStore();

  return (
    <div className="flex flex-wrap justify-between  bg-gray-300 dark:bg-slate-700">
      {currentSeason && currentSeason.allowTeamOwnersToInvite && (
        <Button plain onClick={showInviteOwner}>
          <PlusIcon className="h-5 w-5 mr-2" />
          Invite Team Owner
        </Button>
      )}

      {currentSeason && currentSeason.allowTeamOwnersToShortList && (
        <Button plain onClick={showShortlistPlayers}>
          <PencilIcon className="h-5 w-5 mr-2" />
          Edit Shortlisted Players
        </Button>
      )}
      {currentSeason && currentSeason.allowTeamOwnersToInvite && (
        <Button
          plain
          onClick={showInvitePlayer}
          disabled={invitationDetails.avalaibleInvites < 1}
        >
          <PlusIcon className="h-5 w-5 mr-2" />
          Invite Player
        </Button>
      )}
      {showEdit && (
        <Button plain onClick={showEditTeam}>
          <PencilIcon className="h-5 w-5 mr-2" />
          Edit Team
        </Button>
      )}
    </div>
  );
};
